import useStateHandler from '@/hooks/useStateHandler';
import UserProfileImage from '@/shared-components/cards/components/UserProfileImage';

import './styles/EmptyConversation.css';

export default function EmptyConversation({ orderData }) {
  const { state } = useStateHandler();
  const currentUserId = state.user_session?._id ?? null;
  const orderSellerId = orderData?.order_seller?._id ?? orderData?.order_seller ?? null;
  const isSeller = Boolean(
    currentUserId &&
    orderSellerId &&
    String(currentUserId) === String(orderSellerId)
  );

  return (
    <>
      {
        isSeller ?
          <p className="empty-conversation__buyer-text">
                        No messages yet. Tell the collector more about his recent purchase. 
          </p>
          :
          <div className="empty-conversation__seller-container">
            <UserProfileImage
              image={orderData?.order_seller?.user_image?.image_id}
              typeOfProfile={orderData?.order_seller?.user_type}
              className="empty-conversation__seller-image"
            />

            <span className="empty-conversation__seller-name">
              {orderData?.order_seller?.user_name ?? "Gallery"}
            </span>

            <p className="empty-conversation__seller-text">
                            It is time to learn more about 
                            your recent acquisition!            
            </p>
          </div>
      }
    </>
  );
}
